import styles from './WelcomeLayout.module.css';
import linkedin from '../../icons/linkedin.png';
import email from '../../icons/email.png';
import { ReactNode } from 'react';
import logo from '../../images/LogohvidFinal.png';
import breath from '../../images/breath.png';

const WelcomePage: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.splash}>
                <div className={styles.contact}>
                    <a href="https://www.linkedin.com/company/nordinsight">
                        <img src={linkedin} />
                        LinkedIn
                    </a>
                    <a href="mailto:info@nordinsight.com">
                        <img src={email} />
                        Mail
                    </a>
                </div>
            </div>

            <div className={styles['auth-box']}>
                <div className={styles.logo}>
                    <img src={logo} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default WelcomePage;
